import React, { useEffect, useState } from "react";
import {
  getAllInstituteJobs,
  searchInstituteJobs,
} from "../../../../APIs/GetAPIs";
import { Images } from "../../../../Assets/0a-exporter";
import HoverDropdown from "../../../Common/HoverDropdown/HoverDropdown";
import CreateNewJObCard from "../../../Common/CreateJobCard/CreateJobCard";
import JobPostedCard from "../../../Common/JobPostedCard/JobPostedCard";
import "./job-post-list.style.scss";
import { getAllInstituteJobsPost } from "../../../../APIs/PostAPIS";
const JobPostList = () => {
  const [JobsList, setJobList] = useState([]);
  const [jobParams, setJobParams] = useState({
    job_status: "",
    search: "",
    pageNo: 0,
    pageSize: 20,
    sort: {
      job_title: 0,
    },
  });

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      // let res = await getAllInstituteJobs();
      let res = await getAllInstituteJobsPost(jobParams);
      setJobList(res?.data?.data?.jobData);
    } catch (err) {
      console.log(err.response);
    }
  };

  const handleSearchInstituteJobs = async (title) => {
    if (title) {
      try {
        let res = await searchInstituteJobs(title);
        setJobList(res?.data?.data);
      } catch {
        console.log("errr");
      }
    } else {
      loadData();
    }
  };
  return (
    <div className="job-post-list-main">
      <section className="jplm-left">
        <header className="jplml-header">
          <div className="jplm-search">
            <img src={Images.graySearch} />
            <input
              placeholder="Search Job title"
              onChange={(event) =>
                handleSearchInstituteJobs(event.target.value)
              }
            />
          </div>
          <div className="jplml-right">
            <HoverDropdown title="Job Status" message="Saved As Draft" />
            <HoverDropdown title="Sort by" message="Relevance" />
          </div>
        </header>
        <div className="jplml-body">
          <h4>Job posts({JobsList.length})</h4>
          <div className="jplml-list-wrapper">
            {JobsList && JobsList.length != 0
              ? JobsList.map((job, i) => (
                  <div className="jplmll-card-wrapper" key={i}>
                    <JobPostedCard job={job} />
                  </div>
                ))
              : ""}
            <div className="jplmll-card-wrapper">
              <CreateNewJObCard />
            </div>
          </div>
        </div>
      </section>
      <aside className="jplm-right"></aside>
    </div>
  );
};
export default JobPostList;
